function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.classname0{fill:url(#SVGNUMBER_1_);}\r\n\t.classname1{fill-rule:evenodd;clip-rule:evenodd;fill:#15BFD1\r\n\t;}\r\n\t.classname2{fill-rule:evenodd;clip-rule:evenodd;fill=\"#02A8C3\";}\r\n\t.classname3{fill=\"#02A8C3\";}\r\n\t.classname4{fill-rule:evenodd;clip-rule:evenodd;fill:#F9ACAC;}\r\n\t.classname5{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.classname6{fill-rule:evenodd;clip-rule:evenodd;fill:#FC7A70;}\r\n\t.classname7{fill-rule:evenodd;clip-rule:evenodd;fill=\"#5273E6\";}\r\n\t.classname8{fill-rule:evenodd;clip-rule:evenodd;fill:#FF978F;}\r\n\t.classname9{fill:#F9ACAC;}\r\n\t.classname10{fill=\"#C6E5FA\";}\r\n\t.classname11{fill=\"#3F9DD7\";}\r\n\t.classname12{fill=\"#3394C4\";}\r\n\t.classname13{fill:#2E91AF;}\r\n\t.classname14{fill:#2787AD;}\r\n\t.classname15{fill=\"#F9F9F9\";}\r\n\t.classname16{fill:#CCCCCC;}\r\n\t.classname17{fill:#B9C1B9;}\r\n\t.classname18{fill:#AAB2AA;}\r\n\t.classname19{fill=\"#5273E6\";}\r\n\t.classname20{fill=\"#4567C9\";}\r\n\t.classname21{fill=\"#2F50A5\";}\r\n\t.classname22{fill=\"#45575B\";}\r\n\t.classname23{fill:#FF978F;}\r\n\t.classname24{fill:#FF8E7F;}\r\n\t.classname25{fill:#F96A64;}\r\n\t.classname26{fill:#FFFFFF;}\r\n\t.classname27{fill:#254793;}\r\n\t.classname28{fill=\"#31515E\";}\r\n\t.classname29{fill:#29464F;}\r\n\t.classname30{fill:#2A4249;}\r\n\t.classname31{fill:#2D4851;}\r\n\t.classname32{fill:none;stroke:#F9ACAC;stroke-width:1.96;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "classname0",
  d: "M18,0h67c9.9,0,18,8.1,18,18v65c0,9.9-8.1,18-18,18H18c-9.9,0-18-8.1-18-18V18C0,8.1,8.1,0,18,0z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "XMLID_47_"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_49_",
  fill: "#15BFD1",
  d: "M28.5,59c0,0,1.3-4.2-1.6-8.4c-5.7-8.3-15.5-2.1-7.2,6.7C23.8,61.6,28.3,58.9,28.5,59 L28.5,59z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_48_",
  fill: "#02A8C3",
  d: "M27,57.3c0,0-0.3-0.4-0.9-1.2c0.1,0,0.2-0.1,0.5-0.8c0.3-0.8,0.3-2.2,0.3-2.2L26,56.1 c-0.3-0.4-0.8-1-1.3-1.6c0.1-0.1,0.2-0.4,0.2-1.3c0-1.2-0.6-3.2-0.6-3.2l0.2,4.4c-0.4-0.5-0.9-1-1.4-1.5 c-0.1-0.1-0.2-0.2-0.3-0.3c0.1-0.2,0.1-0.5,0.2-1.1c0-1.2-0.6-3.2-0.6-3.2l0.2,4.2c-2.5-2.5-3.8-3-3.8-3s1.6,1.4,3.7,3.5 l-4.3-0.3c0,0,2,0.6,3.2,0.6c0.8,0,1.1-0.1,1.2-0.2c0.5,0.5,1.1,1.1,1.7,1.7L20,54.9c0,0,2.1,0.4,3.3,0.2c0.7-0.1,1-0.2,1.2-0.3 c0.4,0.4,0.9,0.9,1.3,1.4L23,57.4c0,0,1.4-0.3,2.1-0.7c0.6-0.3,0.7-0.5,0.7-0.6C26.2,56.5,26.6,56.9,27,57.3L27,57.3z"
})), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_36_"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_46_",
  fill: "#15BFD1",
  d: "M27.7,45.8c0,0,2.3-0.5,2.7-2.6c0.4-2.1-0.3-3.6-0.4-3.7C29.9,39.4,25.8,43.1,27.7,45.8 L27.7,45.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_45_",
  fill: "#15BFD1",
  d: "M25,40.7c0,0-0.8-2.2-3-2.6c-2.1-0.3-3.4,0.2-3.4,0.4c0,0.1,0.8,1.6,2.4,2.4 C22.2,41.4,23.9,41.5,25,40.7L25,40.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_44_",
  fill: "#15BFD1",
  d: "M25,40.7c0,0,2.4-0.3,2.9-2.4c0.5-2.1,0-3.7-0.1-3.7C27.7,34.5,23.3,37.9,25,40.7L25,40.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_43_",
  fill: "#15BFD1",
  d: "M27.8,45.8c0,0-1.2-2.1-3.3-2.1c-2.1,0-3.3,0.8-3.3,0.9c0,0.1,1.1,1.5,2.7,2 C25.1,46.9,26.8,46.8,27.8,45.8L27.8,45.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_42_",
  fill: "#15BFD1",
  d: "M22.5,34.4c0,0-0.8-2.2-3-2.6c-2.1-0.3-3.4,0.3-3.4,0.4c0,0.1,0.8,1.6,2.4,2.4 C19.6,35.1,21.4,35.2,22.5,34.4L22.5,34.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_41_",
  fill: "#15BFD1",
  d: "M22.5,34.3c0,0,2.4-0.3,2.9-2.4c0.5-2.1,0-3.7-0.1-3.8C25.2,28.1,20.8,31.5,22.5,34.3 L22.5,34.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_40_",
  fill: "#15BFD1",
  d: "M20.4,27c0,0-0.3-2.4-2.3-3.2c-2-0.8-3.3-0.5-3.5-0.3c-0.1,0.1,0.5,1.8,1.9,2.8 C17.5,27.1,19.2,27.6,20.4,27L20.4,27z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_39_",
  fill: "#15BFD1",
  d: "M20.5,27c0,0,2.4,0.2,3.4-1.7c1-1.9,0.8-3.6,0.7-3.7C24.4,21.6,19.4,23.9,20.5,27L20.5,27z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_38_",
  fill: "#15BFD1",
  d: "M19.7,20.8c0,0,2.3-1.4,1.9-3.7c-0.3-2.4-1.6-3.7-1.8-3.8c-0.1,0-1.5,1.8-1.7,3.8 C18,18.5,18.5,20,19.7,20.8L19.7,20.8z"
})), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_37_",
  className: "st3",
  d: "M29.4,47.9c0,0-9-13-9.5-27.9h-0.3C20,35,29,48.1,29,48.1L29.4,47.9z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#F9ACAC",
  points: "43,45.2 27.1,54.3 27.1,27.6 43,18.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "41,33 29.1,39.8 29.1,28.8 41,22  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FC7A70",
  points: "41,44.5 29.1,51.3 29.1,47.8 41,41.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  ffill: "#FC7A70",
  points: "27.1,27.6 22.8,25 22.8,51.8 27.1,54.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#5273E6",
  points: "26,36.2 23.9,34.9 23.9,47.7 26,48.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#5273E6",
  points: "27.1,29.9 22.8,27.3 22.8,28.5 27.1,31.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#5273E6",
  points: "27.1,32.3 22.8,29.7 22.8,31 27.1,33.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FF978F",
  points: "43,18.5 42,18 27.3,26.6 24.4,25 39.4,16.4 38.6,16 22.8,25 27.1,27.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#F9ACAC",
  points: "39.4,16.4 39.4,19.5 27.3,26.6 24.4,25  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#C6E5FA",
  points: "24.9,25.3 38.8,17.2 41.2,18.5 27.3,26.6  "
})), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_33_"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_35_",
  fill: "#15BFD1",
  d: "M77.1,46.8c0,0-1.6-4.1,0.8-8.6c4.8-8.9,15.2-3.6,7.9,6C82.1,48.9,77.4,46.7,77.1,46.8 L77.1,46.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_34_",
  fill: "#02A8C3",
  d: "M78.5,45c0,0,0.2-0.4,0.8-1.3c-0.1,0-0.2-0.1-0.6-0.7c-0.4-0.7-0.6-2.1-0.6-2.1l1.2,2.8 c0.3-0.4,0.7-1,1.2-1.7c-0.1-0.1-0.2-0.4-0.3-1.2c-0.1-1.2,0.3-3.3,0.3-3.3l0.2,4.4c0.4-0.5,0.8-1.1,1.3-1.7 c0.1-0.1,0.2-0.3,0.3-0.4c-0.1-0.2-0.2-0.5-0.3-1.1c-0.1-1.2,0.3-3.3,0.3-3.3l0.2,4.2c2.3-2.7,3.5-3.4,3.5-3.4s-1.4,1.5-3.4,3.9 l4.3-0.7c0,0-2,0.8-3.2,0.9c-0.8,0.1-1.1,0-1.3-0.1c-0.5,0.6-1,1.2-1.5,1.8l4.3-0.1c0,0-2,0.6-3.3,0.5c-0.7,0-1.1-0.1-1.2-0.2 c-0.4,0.5-0.8,1-1.2,1.5l2.9,1c0,0-1.4-0.1-2.2-0.4c-0.6-0.3-0.7-0.4-0.8-0.5C79.1,44.1,78.8,44.5,78.5,45L78.5,45z"
})), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_5_"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_32_",
  fill: "#15BFD1",
  d: "M69.4,37.2c0,0-2.3-0.5-2.7-2.6c-0.4-2.1,0.3-3.6,0.4-3.7C67.3,30.8,71.3,34.5,69.4,37.2 L69.4,37.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_14_",
  fill: "#15BFD1",
  d: "M72.1,32.1c0,0,0.8-2.2,3-2.6c2.1-0.3,3.4,0.2,3.4,0.4c0,0.1-0.8,1.6-2.4,2.4 C74.9,32.9,73.2,33,72.1,32.1L72.1,32.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_13_",
  fill: "#15BFD1",
  d: "M72.1,32.1c0,0-2.4-0.3-2.9-2.4c-0.5-2.1,0-3.7,0.1-3.7C69.5,25.9,73.8,29.3,72.1,32.1 L72.1,32.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_12_",
  fill: "#15BFD1",
  d: "M69.4,37.2c0,0,1.2-2.1,3.3-2.1c2.1,0,3.3,0.8,3.3,0.9c0,0.1-1.1,1.5-2.7,2 C72,38.3,70.3,38.2,69.4,37.2L69.4,37.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_11_",
  fill: "#15BFD1",
  d: "M74.6,25.8c0,0,0.8-2.2,3-2.6c2.1-0.3,3.4,0.3,3.4,0.4c0,0.1-0.8,1.6-2.4,2.4 C77.5,26.5,75.8,26.6,74.6,25.8L74.6,25.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_10_",
  fill: "#15BFD1",
  d: "M74.6,25.7c0,0-2.4-0.3-2.9-2.4c-0.5-2.1,0-3.7,0.1-3.8C71.9,19.5,76.3,22.9,74.6,25.7 L74.6,25.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_9_",
  fill: "#15BFD1",
  d: "M76.7,18.5c0,0,0.3-2.4,2.3-3.2c2-0.8,3.3-0.5,3.5-0.3c0.1,0.1-0.5,1.8-1.9,2.8 C79.6,18.6,78,19,76.7,18.5L76.7,18.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_8_",
  fill: "#15BFD1",
  d: "M76.6,18.5c0,0-2.4,0.2-3.4-1.7s-0.8-3.6-0.7-3.7C72.7,13,77.7,15.3,76.6,18.5L76.6,18.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_7_",
  fill: "#15BFD1",
  d: "M77.4,12.3c0,0-2.3-1.4-1.9-3.7c0.3-2.4,1.6-3.7,1.8-3.8c0.1,0,1.5,1.8,1.7,3.8 C79.2,9.9,78.6,11.4,77.4,12.3L77.4,12.3z"
})), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_6_",
  className: "st3",
  d: "M67.8,39.4c0,0,9-13,9.5-27.8h0.3c-0.5,14.9-9.6,28-9.6,28.1L67.8,39.4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#3F9DD7",
  points: "41.5,23.1 67.6,38.4 67.6,60.2 41.5,45.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#3394C4",
  points: "81.4,30.2 67.6,38.4 67.6,60.2 81.4,52.4  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#2E91AF",
  points: "41.5,30.7 67.6,45.7 67.6,47.7 41.5,32.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#2E91AF",
  points: "41.5,25.9 67.6,40.8 67.6,42.9 41.5,27.8  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#2787AD",
  points: "81.4,37.9 67.6,45.7 67.6,47.7 81.4,39.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#2787AD",
  points: "81.4,33.1 67.6,40.8 67.6,42.9 81.4,35  "
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#F9F9F9",
  points: "61.6,34.9 63.1,35.8 63.1,49 61.6,48.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#F9F9F9",
  points: "56.1,31.6 57.6,32.5 57.6,45.9 56.1,45  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#F9F9F9",
  points: "50.6,28.5 52,29.3 52,42.5 50.6,41.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#F9F9F9",
  points: "45,25.2 46.6,26.1 46.6,39.4 45,38.5  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#C6E5FA",
  points: "73.6,34.8 72.2,35.7 72.2,48.9 73.6,48.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#C6E5FA",
  points: "79.2,31.5 77.7,32.4 77.7,45.8 79.2,44.9  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#F9F9F9",
  points: "41.5,35.8 67.6,51.1 67.6,60.2 41.5,45.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#C6E5FA",
  points: "81.4,42.9 67.6,51.1 67.6,60.2 81.4,52.4  "
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#CCCCCC",
  points: "81.9,28.8 67.6,37.2 40.9,21.6 55.2,13.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#C6E5FA",
  points: "81.9,28.8 81.9,29.8 67.6,38.4 67.6,37.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#F9F9F9",
  points: "67.6,37.2 40.9,21.6 40.9,22.8 67.6,38.4  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#B9C1B9",
  points: "78.5,28.8 67.4,35.4 43.8,21.6 54.9,15.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#AAB2AA",
  points: "54.9,15.1 78.5,28.8 77.8,29.2 77.8,29.2 54.9,15.8 44.5,22 43.8,21.6  "
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#5273E6",
  points: "72.8,25.5 54.9,15.1 40.9,21.6 67.6,37.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#4567C9",
  points: "81.9,28.8 72.8,25.5 67.6,37.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#4567C9",
  points: "55.2,13.2 54.9,15.1 40.9,21.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#2F50A5",
  points: "81.9,28.8 55.2,13.2 54.9,15.1 72.8,25.5  "
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#45575B",
  d: "M44.5,39.7c0-0.1,0.1-0.1,0.3,0c0.1,0.1,0.3,0.2,0.3,0.3v2c0,0.7-0.4,0.7-1,0.4c-0.6-0.3-1-0.9-1-1.6v-2 c0-0.1,0.1-0.1,0.3,0c0.1,0.1,0.3,0.2,0.3,0.3v2c0,0.3,0.2,0.6,0.5,0.8c0.3,0.2,0.5,0.1,0.5-0.2V39.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#45575B",
  d: "M47.1,44l-0.9-2.3v1.8c0,0.1-0.1,0.1-0.3,0c-0.1-0.1-0.3-0.2-0.3-0.3v-2.8c0-0.1,0.1-0.1,0.3,0 c0.2,0.1,0.3,0.2,0.4,0.5l0.8,2.1v-1.8c0-0.1,0.1-0.1,0.3,0c0.1,0.1,0.3,0.2,0.3,0.3v2.8c0,0.1-0.1,0.1-0.3,0 C47.2,44.3,47.1,44.2,47.1,44z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#45575B",
  d: "M48.2,41.8c0-0.1,0.1-0.1,0.3,0c0.1,0.1,0.3,0.2,0.3,0.3V45c0,0.1-0.1,0.1-0.3,0c-0.1-0.1-0.3-0.2-0.3-0.3 V41.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#45575B",
  d: "M49.1,42.4C49.1,42.4,49.1,42.4,49.1,42.4c0-0.2,0.2-0.1,0.3-0.1c0.1,0.1,0.2,0.1,0.2,0.2l0.7,2.7l0.7-2 c0-0.1,0.1-0.1,0.2,0c0.1,0.1,0.3,0.3,0.3,0.4v0l-0.8,2.3c0,0.1-0.2,0.1-0.4,0c-0.2-0.1-0.3-0.2-0.4-0.4L49.1,42.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#45575B",
  d: "M52.4,45.4l0.7,0.4c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1-0.1,0.2-0.2,0.1l-0.7-0.4v0.9l1.2,0.7 c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1-0.1,0.2-0.2,0.1L52,47c-0.1-0.1-0.2-0.2-0.2-0.3v-2.8c0-0.1,0.1-0.1,0.2,0l1.5,0.9 c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1-0.1,0.2-0.2,0.1l-1.2-0.7V45.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#45575B",
  d: "M54.1,45.2c0-0.1,0.1-0.1,0.2-0.1l0.9,0.5c0.6,0.3,1,0.8,1,1.5c0,0.5-0.2,0.6-0.6,0.5l0.6,1.4 c0,0,0,0.1,0,0.1c0,0.1-0.2,0.2-0.3,0.1c-0.1,0-0.1-0.1-0.2-0.2L55,47.5l-0.4-0.2v1.1c0,0.1-0.1,0.1-0.3,0 c-0.1-0.1-0.3-0.2-0.3-0.3L54.1,45.2L54.1,45.2z M54.7,45.9v0.9l0.5,0.3c0.3,0.2,0.5,0.1,0.5-0.2c0-0.3-0.2-0.6-0.5-0.7 L54.7,45.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#45575B",
  d: "M57.9,49.6c0-0.7-1.4-1.3-1.4-2.3c0-0.7,0.5-0.5,1.1-0.3c0.2,0.1,0.8,0.5,0.8,0.8c0,0.1-0.1,0.3-0.2,0.2 c-0.1-0.1-0.2-0.3-0.6-0.5c-0.3-0.2-0.5-0.2-0.5,0c0,0.5,1.4,1.2,1.4,2.3c0,0.6-0.4,0.7-1,0.3c-0.6-0.3-1-0.9-1-1.1 c0-0.1,0.1-0.2,0.2-0.2c0.2,0.1,0.3,0.5,0.8,0.8C57.7,49.8,57.9,49.8,57.9,49.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#45575B",
  d: "M58.8,48c0-0.1,0.1-0.1,0.3,0c0.1,0.1,0.3,0.2,0.3,0.3v2.8c0,0.1-0.1,0.1-0.3,0c-0.1-0.1-0.3-0.2-0.3-0.3 V48z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#45575B",
  d: "M61.7,49.5c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1-0.1,0.2-0.2,0.1l-0.7-0.4v2.5c0,0.1-0.1,0.1-0.3,0 c-0.1-0.1-0.3-0.2-0.3-0.3v-2.5l-0.7-0.4c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.1,0.1-0.2,0.2-0.1L61.7,49.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#45575B",
  d: "M62.9,52.1C62.9,52,62.9,52,62.9,52.1L62,49.9c0,0,0,0,0-0.1c0-0.1,0.2-0.1,0.4,0c0.1,0.1,0.1,0.1,0.2,0.2 l0.7,1.6l0.7-0.9c0,0,0.1-0.1,0.2,0c0.1,0.1,0.4,0.3,0.4,0.4v0l-0.9,1l0,0v1.1c0,0.1-0.1,0.1-0.3,0c-0.1-0.1-0.3-0.2-0.3-0.3 L62.9,52.1L62.9,52.1z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#F9ACAC",
  points: "65.1,61.5 37.5,77.6 20.7,67.8 48.3,51.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FF978F",
  points: "65.1,55.7 37.5,71.9 37.5,78.2 65.1,62.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FF8E7F",
  points: "36.7,77.2 36.7,72.2 20.7,62.8 20.7,62.1 37.5,71.9 37.5,78.2 20.7,68.3 20.7,67.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#F9ACAC",
  points: "65.1,55.7 37.5,71.9 20.7,62.1 48.3,45.9  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#F96A64",
  points: "62.8,57.1 61.6,57.8 61.6,64.1 62.8,63.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#F96A64",
  points: "60.5,58.5 59.3,59.2 59.3,65.5 60.5,64.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#F96A64",
  points: "41.5,69.7 40.2,70.3 40.2,76.7 41.5,76  "
})), /*#__PURE__*/React.createElement("polygon", {
  fill: "#C6E5FA",
  points: "21.6,63.3 36.7,72.2 36.7,76.5 21.6,67.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#2F50A5",
  points: "33.6,71.5 30.8,69.8 30.8,72.4 32,72.5 33.6,74  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "61.4,55.7 46.2,64.6 32.9,56.8 48.1,47.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FF978F",
  points: "42,67 37.8,69.6 24.4,61.7 28.6,59.2  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#5273E6",
  points: "24.8,56.8 47.5,70.1 61.3,62 38.6,48.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#4567C9",
  points: "24.8,52.1 47.5,65.4 47.5,70.5 24.8,57.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#2F50A5",
  points: "48.1,69.7 48.1,65.6 61.3,57.8 61.3,57.3 47.5,65.4 47.5,70.5 61.3,62.4 61.3,62  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#5273E6",
  points: "24.8,52.1 47.5,65.4 61.3,57.3 38.6,44  "
})), /*#__PURE__*/React.createElement("polygon", {
  fill: "#C6E5FA",
  points: "60.6,58.3 48.1,65.6 48.1,69.1 60.6,61.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "27.8,52 35.9,56.7 46.9,50.3 38.8,45.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#F9ACAC",
  points: "45,61.9 48,63.6 59.1,57.2 56,55.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#254793",
  points: "41.1,59.6 44.1,61.3 55.1,54.9 52.1,53.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#F9ACAC",
  points: "26.3,54.7 32.9,58.5 32.9,60.2 26.3,56.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#F9ACAC",
  points: "39.3,62.4 45.9,66.2 45.9,67.9 39.3,64.1  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M70.5,20.9c0,6-16.5,6-16.5,0v-5.8c0,4,16.5,4,16.5,0L70.5,20.9L70.5,20.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#29464F",
  d: "M70.5,15c0,1.9-3.7,3.5-8.2,3.5c-4.6,0-8.2-1.6-8.2-3.5s3.7-3.5,8.2-3.5S70.5,13,70.5,15z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#3F9DD7",
  d: "M68.4,15c0,1.4-2.7,2.6-6.2,2.6c-3.4,0-6.2-1.2-6.2-2.6c0-1.4,2.7-2.6,6.2-2.6 C65.6,12.4,68.4,13.5,68.4,15z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3394C4",
  d: "M57.2,15.5c0-1.4,2.7-2.6,6.2-2.6c1.4,0,2.7,0.2,3.7,0.5c-1.1-0.7-2.9-1.1-4.9-1.1 c-3.4,0-6.2,1.2-6.2,2.6c0,0.9,1,1.6,2.5,2.1C57.7,16.6,57.2,16.1,57.2,15.5z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#2A4249",
  points: "76.6,14.8 62.3,23.2 62.3,24.2 76.6,15.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#2D4851",
  points: "48.1,14.7 62.3,23.2 62.3,24.2 48.1,15.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#31515E",
  points: "48.1,14.7 62.3,23.2 76.6,14.8 62.3,7  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
  className: "classname32",
  stroke: "#F9ACAC",
  points: "62.1,14.3 70.1,18.7 70.1,24.1  "
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9ACAC",
  d: "M63.6,14.3c0,0.3-0.6,0.6-1.3,0.6c-0.8,0-1.3-0.2-1.3-0.6c0-0.3,0.6-0.6,1.3-0.6C63,13.7,63.6,14,63.6,14.3 z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9ACAC",
  d: "M70.8,25.6v-1.3c0-0.4-0.3-0.8-0.8-0.8c-0.4,0-0.8,0.3-0.8,0.8v1.3C69.5,25.8,70.1,26.2,70.8,25.6z"
}))));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M41.4,82.3c0-0.9,0.1-1.5,0.4-1.9c0.3-0.4,0.7-0.7,1.2-0.7c0.3,0,0.7,0.1,1,0.4c0.3-0.3,0.6-0.4,0.9-0.4 c0.6,0,1,0.2,1.3,0.7c0.3,0.4,0.4,1,0.4,1.7c0,1-0.3,2-0.9,2.9h-1c0.7-1,1-1.9,1-2.9c0-0.5-0.1-0.9-0.2-1.2s-0.3-0.4-0.6-0.4 c-0.2,0-0.4,0.1-0.5,0.2c0.1,0.5,0.2,1.1,0.2,1.6c0,0.9-0.2,1.6-0.5,2c-0.3,0.4-0.7,0.7-1.1,0.7c-0.4,0-0.8-0.2-1.1-0.7 C41.6,84,41.4,83.3,41.4,82.3z M42.3,82.4c0,0.7,0.1,1.2,0.2,1.5c0.2,0.3,0.3,0.4,0.5,0.4c0.2,0,0.4-0.1,0.5-0.4 c0.2-0.3,0.2-0.8,0.2-1.5c0-0.7-0.1-1.2-0.2-1.4c-0.1-0.3-0.3-0.4-0.6-0.4c-0.3,0-0.5,0.1-0.6,0.4C42.3,81.2,42.3,81.7,42.3,82.4z "
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M47.4,83.2c0-0.4,0.1-0.8,0.4-1.1c0.2-0.3,0.5-0.5,0.9-0.5l0.1-0.4c0-0.2-0.1-0.4-0.4-0.5 c-0.3-0.1-0.5-0.4-0.5-0.8h0.9c0,0.2,0.1,0.3,0.4,0.5c0.3,0.1,0.4,0.4,0.4,0.9l-0.1,0.5c0.3,0,0.5,0.2,0.8,0.5s0.4,0.7,0.4,1.1 c0,0.5-0.2,1-0.5,1.3c-0.3,0.3-0.7,0.5-1.2,0.5s-0.9-0.2-1.2-0.5C47.6,84.2,47.4,83.8,47.4,83.2z M48.3,83.2 c0,0.4,0.1,0.7,0.2,0.8c0.2,0.2,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.6-0.2c0.1-0.1,0.2-0.4,0.2-0.8c0-0.3-0.1-0.5-0.2-0.7 c-0.1-0.2-0.3-0.2-0.5-0.2c-0.3,0-0.5,0.1-0.6,0.2C48.3,82.7,48.3,82.9,48.3,83.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M51.4,82.2c0-0.8,0.1-1.3,0.4-1.8c0.3-0.5,0.7-0.7,1.2-0.7s0.9,0.2,1.2,0.7c0.3,0.4,0.4,1.1,0.4,1.8 c0,0.7-0.1,1.6-0.3,2.7h-0.9c0.3-1,0.4-2,0.4-2.8c0-0.6-0.1-1-0.2-1.3c-0.2-0.3-0.3-0.4-0.6-0.4c-0.2,0-0.4,0.1-0.5,0.4 c-0.1,0.3-0.2,0.7-0.2,1.3c0,0.8,0.2,1.8,0.5,2.8h-1C51.6,83.8,51.4,82.9,51.4,82.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M55.4,81.7c0-0.6,0.2-1.1,0.4-1.4c0.3-0.3,0.7-0.5,1.1-0.5s0.7,0.2,0.9,0.5c0.2-0.3,0.5-0.5,0.9-0.5 c0.4,0,0.7,0.2,0.9,0.5c0.1-0.2,0.2-0.3,0.4-0.4c0.1-0.1,0.3-0.1,0.5-0.1c0.4,0,0.8,0.2,1.1,0.5s0.4,0.8,0.4,1.4 c0,0.4-0.2,1-0.5,1.5h-1.1c0.5-0.6,0.8-1.1,0.8-1.5c0-0.5-0.1-0.8-0.2-0.9c-0.1-0.1-0.3-0.2-0.5-0.2c-0.4,0-0.5,0.3-0.5,0.9v0.9 h-0.8v-0.9c0-0.5-0.2-0.9-0.5-0.9c-0.3,0-0.5,0.3-0.5,0.9v0.9h-0.8v-0.9c0-0.6-0.2-0.9-0.5-0.9c-0.2,0-0.3,0.1-0.5,0.2 c-0.2,0.2-0.2,0.4-0.2,0.9c0,0.8,0.5,1.4,1.4,2c1.1,0,1.9,0.1,2.4,0.3s0.8,0.5,0.8,1h-1.1c-0.1-0.3-0.3-0.4-0.7-0.5 c-0.3-0.1-0.8-0.1-1.2-0.1c-0.9,0-1.5,0.1-2,0.2v-0.8l0.5-0.1C55.8,83.2,55.4,82.5,55.4,81.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M63,82.2c0-0.8,0.1-1.3,0.4-1.8c0.3-0.5,0.7-0.7,1.2-0.7c0.5,0,0.9,0.2,1.2,0.7c0.3,0.4,0.4,1.1,0.4,1.8 c0,0.7-0.1,1.6-0.3,2.7H65c0.3-1,0.4-2,0.4-2.8c0-0.6-0.1-1-0.2-1.3s-0.3-0.4-0.6-0.4c-0.2,0-0.4,0.1-0.5,0.4 c-0.1,0.3-0.2,0.7-0.2,1.3c0,0.8,0.2,1.8,0.5,2.8h-1C63.1,83.8,63,82.9,63,82.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M67.1,83.3v-3.5h0.8v3.5c0,0.3,0.1,0.6,0.2,0.8c0.1,0.2,0.3,0.3,0.5,0.3c0.2,0,0.4-0.1,0.6-0.2 c0.1-0.2,0.2-0.4,0.2-0.7c0-0.4-0.1-0.8-0.3-1c-0.2-0.2-0.3-0.7-0.3-1.4h0.8c0,0.5,0.1,1,0.3,1.2c0.2,0.2,0.3,0.7,0.3,1.2 c0,0.5-0.2,0.9-0.5,1.2c-0.3,0.3-0.7,0.5-1.2,0.5c-0.5,0-0.9-0.2-1.2-0.5C67.2,84.2,67,83.8,67.1,83.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M71.1,82.2c0-0.8,0.1-1.3,0.4-1.8c0.3-0.5,0.7-0.7,1.2-0.7s0.9,0.2,1.2,0.7c0.3,0.4,0.4,1.1,0.4,1.8 c0,0.7-0.1,1.6-0.3,2.7h-0.9c0.3-1,0.4-2,0.4-2.8c0-0.6-0.1-1-0.2-1.3c-0.2-0.3-0.3-0.4-0.6-0.4c-0.2,0-0.4,0.1-0.5,0.4 c-0.1,0.3-0.2,0.7-0.2,1.3c0,0.8,0.2,1.8,0.5,2.8h-0.9C71.2,83.8,71.1,82.9,71.1,82.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M75.2,83.3v-3.5H76v3.5c0,0.3,0.1,0.6,0.2,0.8c0.1,0.2,0.3,0.3,0.5,0.3c0.2,0,0.4-0.1,0.6-0.2 c0.1-0.2,0.2-0.4,0.2-0.7c0-0.4-0.1-0.8-0.3-1C77.1,82,77,81.6,77,80.9h0.8c0,0.5,0.1,1,0.3,1.2c0.2,0.2,0.3,0.7,0.3,1.2 c0,0.5-0.2,0.9-0.5,1.2c-0.3,0.3-0.7,0.5-1.2,0.5c-0.5,0-0.9-0.2-1.2-0.5C75.3,84.2,75.1,83.8,75.2,83.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M81.3,81.7c0-0.7,0.2-1.1,0.5-1.5c0.3-0.3,0.7-0.5,1.1-0.5c0.4,0,0.7,0.2,1,0.4c0.2-0.3,0.6-0.4,1-0.4 c0.5,0,0.9,0.2,1.2,0.5c0.3,0.3,0.4,0.8,0.4,1.3c0,0.6-0.1,1.1-0.4,1.6h-1c0.3-0.4,0.5-1,0.5-1.6c0-0.3-0.1-0.6-0.2-0.8 c-0.2-0.2-0.3-0.3-0.6-0.3c-0.4,0-0.5,0.2-0.5,0.6v1.3h-0.8V81c0-0.4-0.2-0.6-0.5-0.6c-0.2,0-0.4,0.1-0.5,0.3 c-0.2,0.2-0.2,0.5-0.2,0.9c0,0.7,0.4,1.3,1.1,2c0.5,0,1,0.1,1.5,0.3s0.8,0.5,1,1h-1.1c-0.1-0.2-0.3-0.4-0.6-0.4 c-0.2-0.1-0.5-0.1-0.9-0.1c-0.4,0-0.9,0.1-1.5,0.2v-0.8l0.6-0.1C81.6,83.1,81.3,82.4,81.3,81.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M87.1,82.2c0-0.8,0.1-1.3,0.4-1.8c0.3-0.5,0.7-0.7,1.2-0.7s0.9,0.2,1.2,0.7c0.3,0.4,0.4,1.1,0.4,1.8 c0,0.7-0.1,1.6-0.3,2.7h-0.9c0.3-1,0.4-2,0.4-2.8c0-0.6-0.1-1-0.2-1.3c-0.2-0.3-0.3-0.4-0.6-0.4c-0.2,0-0.4,0.1-0.5,0.4 S88,81.6,88,82.2c0,0.8,0.2,1.8,0.5,2.8h-1C87.3,83.8,87.1,82.9,87.1,82.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M91.1,83c0-0.4,0.1-0.8,0.3-1.1l0.8,0.3c-0.1,0.4-0.2,0.7-0.2,0.9c0,0.4,0.1,0.8,0.2,1 c0.1,0.2,0.3,0.3,0.5,0.3c0.3,0,0.5-0.1,0.7-0.4c0.1-0.2,0.2-0.5,0.2-0.9c0-0.6-0.2-1.1-0.7-1.5c-0.5-0.4-0.7-1-0.7-1.7H93 c0,0.4,0.2,0.9,0.7,1.4c0.5,0.5,0.7,1.1,0.7,1.9c0,0.5-0.1,1-0.4,1.4c-0.3,0.4-0.7,0.6-1.2,0.6c-0.5,0-0.9-0.2-1.2-0.6 C91.3,84,91.1,83.6,91.1,83z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M41.5,88.5l0.3-0.7c0.2,0.1,0.3,0.2,0.4,0.2h0.3c0.2,0,0.4,0.1,0.6,0.4c0.2-0.3,0.4-0.4,0.8-0.4 c0.2,0,0.5,0.1,0.7,0.3c0.2,0.2,0.3,0.4,0.3,0.7v2.4c0,0.7-0.1,1.2-0.4,1.5c-0.3,0.3-0.7,0.4-1.2,0.4c-0.5,0-0.9-0.1-1.2-0.4 c-0.3-0.3-0.5-0.7-0.5-1.2c0-0.2,0.1-0.5,0.2-0.9l0.8,0.3c-0.1,0.2-0.2,0.5-0.2,0.8c0,0.2,0.1,0.3,0.2,0.5 c0.1,0.1,0.3,0.2,0.6,0.2c0.3,0,0.5-0.1,0.6-0.2c0.1-0.1,0.2-0.4,0.2-1V89c0-0.2-0.1-0.2-0.3-0.2c-0.2,0-0.3,0.1-0.3,0.2v1.1h-0.8 v-1.1c0-0.1-0.1-0.2-0.2-0.2h-0.4C42,88.8,41.8,88.7,41.5,88.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M45.9,91.5v-2.3c0-0.4,0.1-0.7,0.4-0.9c0.2-0.2,0.5-0.3,0.8-0.3H49v0.8h-1.8c-0.3,0-0.4,0.1-0.4,0.3v1 c0.3-0.2,0.5-0.4,0.8-0.4c0.4,0,0.8,0.1,1.1,0.4c0.3,0.3,0.4,0.7,0.4,1.3c0,0.6-0.1,1-0.4,1.3c-0.3,0.3-0.7,0.5-1.1,0.5 c-0.5,0-0.9-0.2-1.2-0.5C46.1,92.4,45.9,92,45.9,91.5z M46.8,91.5c0,0.4,0.1,0.7,0.2,0.8c0.2,0.1,0.4,0.2,0.6,0.2 c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.2-0.4,0.2-0.8c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.3-0.2-0.5-0.2c-0.2,0-0.4,0.1-0.6,0.2 C46.9,90.9,46.8,91.2,46.8,91.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M50.1,90.5c0-0.8,0.1-1.3,0.4-1.8c0.3-0.5,0.7-0.7,1.2-0.7s0.9,0.2,1.2,0.7c0.3,0.4,0.4,1.1,0.4,1.8 c0,0.7-0.1,1.6-0.3,2.7h-0.9c0.3-1,0.4-2,0.4-2.8c0-0.6-0.1-1-0.2-1.3s-0.3-0.4-0.6-0.4c-0.2,0-0.4,0.1-0.5,0.4 c-0.1,0.3-0.2,0.7-0.2,1.3c0,0.8,0.2,1.8,0.5,2.8h-1C50.2,92.1,50.1,91.2,50.1,90.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M54.2,91.7c0-0.2,0.1-0.5,0.2-0.8l0.8,0.2c-0.1,0.2-0.2,0.4-0.2,0.8c0,0.2,0.1,0.3,0.2,0.5 c0.1,0.1,0.3,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.2c0.1-0.1,0.2-0.2,0.2-0.4v-0.5c0-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.2-0.2-0.4-0.2h-0.4 V90h0.4c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.1-0.3,0.1-0.5c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.3-0.2-0.5-0.2c-0.3,0-0.5,0.1-0.6,0.2 c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.4l-0.8,0.3c-0.1-0.2-0.1-0.4-0.1-0.7c0-0.3,0.1-0.6,0.4-0.9c0.3-0.2,0.7-0.4,1.1-0.4 s0.8,0.1,1.1,0.4c0.3,0.3,0.4,0.6,0.4,1c0,0.4-0.2,0.8-0.5,1c0.4,0.3,0.6,0.7,0.6,1.2c0,0.5-0.1,0.9-0.4,1.2 c-0.3,0.3-0.7,0.4-1.2,0.4s-0.9-0.1-1.2-0.4C54.4,92.6,54.2,92.2,54.2,91.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M58.4,91.7c0-0.3,0.1-0.5,0.2-0.9l0.8,0.4c-0.1,0.2-0.1,0.4-0.1,0.7s0.1,0.4,0.2,0.5 c0.1,0.1,0.3,0.2,0.5,0.2c0.3,0,0.5-0.1,0.7-0.2c0.1-0.1,0.2-0.4,0.2-0.8v-2.3c0-0.2-0.1-0.3-0.2-0.4s-0.3-0.1-0.5-0.1 c-0.3,0-0.5,0.1-0.5,0.2c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.2,0,0.3,0.1,0.5l-0.7,0.3c-0.2-0.3-0.3-0.5-0.3-0.8c0-0.3,0.1-0.7,0.4-0.9 c0.3-0.3,0.7-0.4,1.1-0.4c0.5,0,0.9,0.1,1.2,0.4c0.3,0.2,0.4,0.5,0.4,0.9v2.3c0,0.6-0.2,1.1-0.5,1.3c-0.3,0.3-0.7,0.4-1.2,0.4 c-0.4,0-0.7-0.1-1.1-0.3C58.6,92.7,58.4,92.3,58.4,91.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M62.5,91.1c0-0.5,0.1-0.9,0.2-1.3s0.4-0.7,0.7-1c0.6-0.5,1.4-0.8,2.5-0.8v0.8c-1.2,0.1-2,0.3-2.2,0.7 l0.5-0.1c0.3,0,0.6,0.2,0.9,0.5c0.3-0.3,0.6-0.5,1-0.5c0.5,0,0.9,0.1,1.2,0.4s0.4,0.8,0.4,1.4c0,0.8-0.2,1.4-0.7,2.1h-1.2 c0.7-0.7,1.1-1.4,1.1-2.1c0-0.4-0.1-0.7-0.2-0.8c-0.2-0.2-0.3-0.3-0.6-0.3c-0.3,0-0.5,0.2-0.5,0.7v1.2h-0.8v-1.2 c0-0.4-0.2-0.7-0.5-0.7c-0.5,0-0.8,0.3-0.8,1.1c0,0.8,0.4,1.5,1.1,2.2h-1.2C62.8,92.5,62.5,91.8,62.5,91.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M68.6,91.5V88h0.8v3.5c0,0.3,0.1,0.6,0.2,0.8c0.1,0.2,0.3,0.3,0.5,0.3c0.2,0,0.4-0.1,0.6-0.2 c0.1-0.2,0.2-0.4,0.2-0.7c0-0.4-0.1-0.8-0.3-1c-0.2-0.2-0.3-0.7-0.3-1.4h0.8c0,0.5,0.1,1,0.3,1.2c0.2,0.2,0.3,0.7,0.3,1.2 c0,0.5-0.2,0.9-0.5,1.2c-0.3,0.3-0.7,0.5-1.2,0.5c-0.5,0-0.9-0.2-1.2-0.5C68.7,92.4,68.6,92,68.6,91.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M72.8,90.5c0-0.8,0.1-1.3,0.4-1.8c0.3-0.5,0.7-0.7,1.2-0.7s0.9,0.2,1.2,0.7c0.3,0.4,0.4,1.1,0.4,1.8 c0,0.7-0.1,1.6-0.3,2.7h-0.9c0.3-1,0.4-2,0.4-2.8c0-0.6-0.1-1-0.2-1.3c-0.2-0.3-0.3-0.4-0.6-0.4c-0.2,0-0.4,0.1-0.5,0.4 c-0.1,0.3-0.2,0.7-0.2,1.3c0,0.8,0.2,1.8,0.5,2.8h-1C72.9,92.1,72.8,91.2,72.8,90.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M76.9,90.8c0-0.9,0.2-1.5,0.6-1.9c0.4-0.3,0.8-0.5,1.1-0.6c0-0.1,0-0.1,0-0.1c0,0,0-0.1,0-0.1h0.9l-0.1,0.2 c0.3,0,0.7,0.2,1.1,0.5c0.4,0.3,0.6,1,0.7,1.9c0,0.8-0.2,1.4-0.5,1.8c-0.4,0.4-0.9,0.7-1.5,0.7c-0.7,0-1.2-0.2-1.5-0.7 C77.1,92.1,76.9,91.5,76.9,90.8z M77.8,90.8c0,0.5,0.1,0.9,0.3,1.3c0.2,0.3,0.5,0.5,0.9,0.5c0.4,0,0.8-0.2,0.9-0.5 c0.2-0.3,0.3-0.7,0.3-1.3c0-0.6-0.1-1-0.3-1.3c-0.2-0.2-0.4-0.4-0.7-0.5l0.1,2.5h-0.8l0-2.5c-0.2,0.1-0.4,0.3-0.6,0.5 C77.9,89.7,77.8,90.2,77.8,90.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M82,91.7c0-0.3,0.1-0.5,0.2-0.9l0.8,0.4c-0.1,0.2-0.1,0.4-0.1,0.7s0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2 c0.3,0,0.5-0.1,0.7-0.2c0.1-0.1,0.2-0.4,0.2-0.8v-2.3c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.5,0.1-0.5,0.2 C83,89,83,89.2,83,89.3c0,0.2,0,0.3,0.1,0.5l-0.7,0.3c-0.2-0.3-0.3-0.5-0.3-0.8c0-0.3,0.1-0.7,0.4-0.9c0.3-0.3,0.7-0.4,1.1-0.4 c0.5,0,0.9,0.1,1.2,0.4c0.3,0.2,0.4,0.5,0.4,0.9v2.3c0,0.6-0.2,1.1-0.5,1.3c-0.3,0.3-0.7,0.4-1.2,0.4c-0.4,0-0.7-0.1-1.1-0.3 C82.2,92.7,82,92.3,82,91.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M86.1,90.8c0-0.9,0.2-1.5,0.6-1.9c0.4-0.3,0.8-0.5,1.1-0.6c0-0.1,0-0.1,0-0.1c0,0,0-0.1,0-0.1h0.9l-0.1,0.2 c0.3,0,0.7,0.2,1.1,0.5c0.4,0.3,0.6,1,0.7,1.9c0,0.8-0.2,1.4-0.5,1.8c-0.4,0.4-0.9,0.7-1.5,0.7c-0.7,0-1.2-0.2-1.5-0.7 C86.3,92.1,86.1,91.5,86.1,90.8z M87,90.8c0,0.5,0.1,0.9,0.3,1.3c0.2,0.3,0.5,0.5,0.9,0.5c0.4,0,0.8-0.2,0.9-0.5s0.3-0.7,0.3-1.3 c0-0.6-0.1-1-0.3-1.3c-0.2-0.2-0.4-0.4-0.7-0.5l0.1,2.5h-0.8l0-2.5c-0.2,0.1-0.4,0.3-0.6,0.5C87.1,89.7,87,90.2,87,90.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31515E",
  d: "M91.2,90.5c0-0.8,0.1-1.3,0.4-1.8c0.3-0.5,0.7-0.7,1.2-0.7s0.9,0.2,1.2,0.7c0.3,0.4,0.4,1.1,0.4,1.8 c0,0.7-0.1,1.6-0.3,2.7h-0.9c0.3-1,0.4-2,0.4-2.8c0-0.6-0.1-1-0.2-1.3c-0.2-0.3-0.3-0.4-0.6-0.4c-0.2,0-0.4,0.1-0.5,0.4 c-0.1,0.3-0.2,0.7-0.2,1.3c0,0.8,0.2,1.8,0.5,2.8h-1C91.3,92.1,91.2,91.2,91.2,90.5z"
}));

var SvgTouSmall = function SvgTouSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\xD1\\xEB\\xEE\\xE9_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 101",
    style: {
      enableBackground: "new 0 0 103 101"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGNUMBER_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 52.5,
    x2: 103,
    y2: 52.5,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC37D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9A4F"
    }
  })), _ref3, _ref4, _ref5));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTouSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tou-small.5edaf7a6.svg";
export { ForwardRef as ReactComponent };